/* global google */
/* global AMap */
/**
 * Map widget
**/

import {
  isEmpty,
  isAutonavi,
} from '../Utils';
import GlobalVars from '../GlobalVars';

let map = {};
let storesMarkersArray = [];
let currentOpenInfowindow = false;
// const imgpath = `${GlobalVars.CDN_url}/img/${GlobalVars.Brand}/map/store_marker.png`;
const imgpath = '/img/occ2016/style-guide/store-locator/locator-store2-full-icon-76.png';
// let geocoder = {};

/**
 * Clear markers array
 */
function clearMarkers() {
  for (let i = 0; i < storesMarkersArray.length; i += 1) {
    storesMarkersArray[i].setMap(null);
  }
  storesMarkersArray = [];
}

/**
 * Open Google map marker
 */
function openMarker(index) {
  google.maps.event.trigger(storesMarkersArray[index], 'click');
}

/**
 * Create google marker on map
 */
function addMarker(pos, markerTitle, iconObject, infowindow) {
  let marker = null;
  if (isAutonavi()) {
    marker = AMap.Marker({
      map,
      position: pos,
    });
  } else {
    marker = new google.maps.Marker({
      position: pos,
      title: markerTitle,
      icon: iconObject,
    });
    if (!isEmpty(infowindow)) {
      google.maps.event.addListener(marker, 'click', () => {
        if (currentOpenInfowindow !== false) {
          currentOpenInfowindow.close();
        }
        currentOpenInfowindow = infowindow;
        infowindow.open(map, marker);
      });
    }
    marker.setMap(map);
  }

  return marker;
}

/**
 * Create a google marker store on map (add to markers array)
 */
function addStoreMarker(pos, markerTitle, iconObject, infowindow) {
  const marker = addMarker(pos, markerTitle, iconObject, infowindow);
  storesMarkersArray.push(marker);
}

/**
 * Set center of the map to a specific address with geocoder
 */
 /*
function getGeocoderPosition(searchAddress) {
  geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: searchAddress }, (results, status) => {
    if (status === google.maps.GeocoderStatus.OK) {
      console.log(results[0].geometry.location);
      console.log(results);
      return results;
    }
    return false;
  });
}
*/

/**
 * Set map zoom
 */
function setZoom(zoomNb) {
  map.setZoom(zoomNb);
}

/**
 * Set map center
 */
function setCenter(latitude, longitude) {
  const googlePos = new google.maps.LatLng(latitude, longitude);
  map.setCenter(googlePos);
}

/**
 * map initialisation
 * @param  {String} idWrapper - The element ID.
 * @param  {Object} position - Add a marker to the position { lat, lon }
 */
function init(idWrapper, position) {
  const zoom = 16;

  if (isAutonavi()) {
    // AutoNavi is used for China

    const pos = new AMap.LngLat(position.lon, position.lat);

    map = new AMap.Map(idWrapper, {
      center: pos,
      level: 12,
    });

    new AMap.Marker({ // eslint-disable-line no-new
      map,
      icon: imgpath,
      position: [position.lon, position.lat],
    });
  } else {
    // Google Maps is used for all other countries

    google.maps.visualRefresh = true;

    const pos = new google.maps.LatLng(position.lat, position.lon);

    map = new google.maps.Map(document.getElementById(idWrapper), {
      zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      center: pos,
      streetViewControl: true,
      scrollwheel: false,
    });

    // block zoom control on street view for mobile only
    // avoiding possible bug on frenetic click (QA)
    if (GlobalVars.isMobile !== null && GlobalVars.isMobile !== undefined) {
      const panorama = map.getStreetView();
      panorama.setOptions({ zoomControl: false });
    }
  }
}

export {
  init,
  addMarker,
  addStoreMarker,
  openMarker,
  clearMarkers,
  setZoom,
  setCenter,
};

export default init;



// WEBPACK FOOTER //
// ./js/common/widgets/Map.js